import React from 'react';
import { Sparkles } from 'lucide-react';
import { resolveAssetUrl } from '../../../lib/assets';
import { pageVars } from '../../../data/motifs';

// Live phone-framed preview of the public business page. Reflects the current
// surface + accent motif and identity (name/tagline/cover) as the owner edits,
// before anything is saved. Non-interactive.
export default function SettingsPreview({ surface, accent, template, name, tagline, coverUrl, region, sampleLabel, samplePrice, ctaLabel }) {
  const pv = pageVars(surface, accent, template === 'business_card' ? 'business_card' : template);
  const hasCover = !!coverUrl;
  const heroColor = hasCover ? '#FFFFFF' : 'var(--text-primary)';
  const heroSub = hasCover ? 'rgba(255,255,255,0.82)' : 'var(--text-muted)';
  const cardLabel = template === 'menu' ? 'Dienas piedāvājums' : template === 'reservations' ? 'Pakalpojums' : 'Par mums';

  return (
    <div className="mx-auto" style={{ width: 272 }} data-testid="settings-live-preview">
      <p className="text-white/50 text-xs font-semibold text-center mb-2">Kā izskatās tava lapa</p>
      <div className="rounded-[2.2rem] border-[7px] border-black bg-black shadow-2xl overflow-hidden" style={{ height: 544 }}>
        <div className="w-full h-full overflow-hidden" style={{ ...pv, background: 'var(--bg-page)' }}>
          {/* Hero */}
          <div className="relative" style={{ height: 184 }}>
            {hasCover
              ? <img src={resolveAssetUrl(coverUrl)} alt="" className="absolute inset-0 w-full h-full object-cover" />
              : <div className="absolute inset-0" style={{ background: 'radial-gradient(120% 90% at 70% 0%, var(--accent-ring), var(--bg-page) 60%)' }} />}
            <div className="absolute inset-0" style={{ background: hasCover
              ? 'linear-gradient(to top, var(--bg-page) 0%, rgba(0,0,0,0.5) 42%, transparent 100%)'
              : 'linear-gradient(to top, var(--bg-page) 4%, transparent 60%)' }} />
            <div className="absolute inset-x-0 bottom-0 p-3.5">
              <p className="text-[9px] font-bold uppercase tracking-[0.22em] flex items-center gap-1" style={{ color: 'var(--accent)' }}>
                <Sparkles className="w-2.5 h-2.5" /> {region || 'Latvija'}
              </p>
              <p className="text-xl font-light leading-tight mt-0.5 truncate" style={{ color: heroColor, fontFamily: 'Outfit, sans-serif' }}>
                {name || 'Tavs uzņēmums'}
              </p>
              {tagline ? <p className="text-[10px] mt-1 leading-snug line-clamp-2" style={{ color: heroSub }}>{tagline}</p> : null}
            </div>
          </div>
          {/* Body */}
          <div className="p-3.5 space-y-3">
            <button className="w-full h-9 rounded-full text-xs font-bold" style={{ background: 'var(--accent)', color: 'var(--accent-contrast)' }}>
              {ctaLabel || 'Rezervēt'}
            </button>
            <div className="rounded-xl p-3 shadow-sm" style={{ background: 'var(--bg-card)', border: '1px solid var(--border-card)' }}>
              <p className="text-[9px] font-bold uppercase tracking-wider" style={{ color: 'var(--accent)' }}>{cardLabel}</p>
              <p className="text-xs font-semibold mt-1 truncate" style={{ color: 'var(--text-primary)' }}>{sampleLabel || 'Piemēra pozīcija'}</p>
              {samplePrice ? <p className="text-sm font-bold mt-0.5" style={{ color: 'var(--accent)' }}>€{Number(samplePrice).toFixed(2)}</p> : null}
            </div>
            <div className="rounded-xl p-3" style={{ background: 'var(--bg-card)', border: '1px solid var(--border-card)' }}>
              <div className="h-2 w-2/3 rounded" style={{ background: 'var(--border-divider)' }} />
              <div className="h-2 w-1/2 rounded mt-2" style={{ background: 'var(--border-divider)' }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
